<template>
    <div class="feishu-button">
        <el-input v-model="url"></el-input>
        <el-button type="primary"
            @click="openFeishuDoc('https://k0waenh04wu.feishu.cn/docx/Ke87dIjVdoJAnUxEMEBcBjScnLd?contentTheme=DARK&feed_id=7273018331438448644&last_doc_message_id=7273018438153437187&sourceType=feed&theme=light&useNewLarklet=1#part-ET6GdAEwdoESXMxipyNcL4AJnMA')">打开</el-button>
        <div id="your-mount-point">
        </div>
    </div>
</template>
<!--在网页 html 中-->
<script src="https://lf1-cdn-tos.bytegoofy.com/goofy/locl/lark/external_js_sdk/h5-js-sdk-1.1.3.js"></script>
<script>
    export default {
        name: 'FeiShuButton',
        data () {
            return {
                url: '',
            }
        },
        methods: {
            openFeishuDoc (url) {
                document.getElementById('your-mount-point').innerHTML = ''
                this.$axios.get('api/third_feishu_sdk').then(({data}) => {
                    if (data.code === 200) {
                        var configSet = {
                                    HEADER: {
                                        enable: false, //  隐藏头部
                                     },
                                    MODAL: {
                                        outerMask: true,
                                    },
                                    LIKE: {
                                        enable: false
                                    },
                                    COMMENT: {
                                        enable: false
                                    }
                                }
                        var config = {...data.data,...configSet}
                        window.webComponent.config(config).then(res => {
                            var myComponent = window.webComponent.render('DocsComponent',{
                                src: url,
                                minHeight: '500px',
                                width: '100%',
                                theme: 'dark',
                            },document.querySelector('#your-mount-point'))
                            myComponent.event.onMountSuccess(function(item) {
                                alert('success')
                               item.config.setFeatureConfig({
                                    HEADER: {
                                        enable: false, //  隐藏头部
                                     },
                                    MODAL: {
                                        outerMask: true,
                                    },
                                    LIKE: {
                                        enable: false
                                    },
                                    COMMENT: {
                                        enable: false
                                    }
                                }) 
                            })
                                // myComponent.config.setFeatureConfig({
                                //     HEADER: {
                                //         enable: false, //  隐藏头部
                                //      },
                                //     MODAL: {
                                //         outerMask: true,
                                //     },
                                //     LIKE: {
                                //         enable: false
                                //     },
                                //     COMMENT: {
                                //         enable: false
                                //     }
                                // })
                        })
                    }
                }).catch()
            }
        }
    }
</script>

<style scoped>
.feishu-button {
    /* margin-left: 1.25rem; */
    padding: 1.82rem 0.4rem 0.4rem 0.4rem;
}
</style>


// WEBPACK FOOTER //
// src/pages/ysy/FeishuButton.vue